import api from "./axios";

export const getNotifications = async (limit = 50) => {
  const response = await api.get("/notifications", { params: { limit } });
  return response.data;
};

export const markNotificationRead = async (id) => {
  const response = await api.patch(`/notifications/${id}/read`);
  return response.data;
};

export const markAllNotificationsRead = async () => {
  const response = await api.patch("/notifications/read-all");
  return response.data;
};
